export default __webpack_public_path__ + "static/media/dds5168b-3.daa9980a.png";